import { useInfiniteQuery } from 'react-query';

import { CursorCollectionResponse } from 'types/api_response';
import {
  baseApiUrl,
  fetcher,
  infiniteEmptyResults,
  ServerErrorResponse,
  createParamString,
} from 'data_sources/constants';
import { Job, JobType } from '../../_types';

export default function useOrganizationUserImports<T extends Job>(
  organizationId: string,
  params = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/phoenix/job-service/v1/organizations/${organizationId}/jobs/job-type/${JobType.ImportUsers.toString()}`;

  return useInfiniteQuery<CursorCollectionResponse<T>, ServerErrorResponse>(
    ['organization_user_imports', organizationId, params],
    async ({ pageParam, signal }): Promise<CursorCollectionResponse<T>> => {
      try {
        const paramString = createParamString({
          limit: 10,
          ...params,
        });
        const data: CursorCollectionResponse<T> = await fetcher({
          method: 'get',
          url: pageParam || `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.lastKey && lastPage.content.length > 0) {
          const paramString = createParamString({
            ...params,
            lastKey: lastPage.lastKey,
          });
          return `${url}?${paramString}`;
        }
      },
      ...options,
    }
  );
}
